import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import "./CustomButton.css";

export default function CustomButton(props) {
  return (
    <Button
      className={props.className}
      variant={props.variant}
      icon={props.icon}
      style={{
        backgroundColor: props.backgroundColor,
        fontFamily: props.fontFamily,
        color: props.fontColor,
        fontSize: props.fontSize,
        border: props.borderColor,
        width: props.width,
      }}
      disabled={props.disabled}
    >
      <Link
        to={props.href}
        className="custom-button-container"
        style={{
          fontFamily: props.fontFamily,
          color: props.fontColor,
          fontSize: props.fontSize,
        }}
        rel={props.rel}
        target={props.target}
      >
        <span className="btn-icon">{props.icon}</span>
        {props.content}
      </Link>
    </Button>
  );
}
